<template>
  <header class="bar">
    <ol class="steps" aria-label="Progreso de la configuración">
      <li v-for="(s, i) in STEPS" :key="s.key" class="step" :class="{ 'step--done': i < current, 'step--active': i === current }" :aria-current="i === current ? 'step' : undefined">
        <span v-if="i > 0" class="step__line" :class="lineClass(i)"></span>
        <span class="step__circle" :class="{ 'step__circle--pulse': pulse === i }">
          <span v-if="i < current" class="mdi mdi-check"></span>
          <template v-else>{{ i + 1 }}</template>
        </span>
        <span class="step__label">{{ s.label }}</span>
      </li>
    </ol>
    <div class="bar__info">Paso {{ current + 1 }} de {{ STEPS.length }} · Tiempo estimado: {{ remaining }} {{ remaining === 1 ? 'minuto' : 'minutos' }}</div>
  </header>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { STEPS } from './onboardingFormat'

const props = defineProps({ current: { type: Number, required: true } })

const remaining = computed(() => STEPS.slice(props.current).reduce((sum, s) => sum + s.minutes, 0))

// El círculo que acaba de completarse da un pequeño "latido".
const pulse = ref(-1)
watch(() => props.current, (now, before) => {
  if (now > before) {
    pulse.value = before
    setTimeout(() => { pulse.value = -1 }, 450)
  }
})

// Línea entre el paso i-1 y el i: verde si ya se recorrió, punteada hacia el siguiente, gris más allá.
const lineClass = (i) => (i <= props.current ? 'step__line--done' : i === props.current + 1 ? 'step__line--next' : '')
</script>

<style scoped>
.bar { height: 72px; flex-shrink: 0; display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 0 28px; background: #fff; border-bottom: 1px solid #f1f5f9; }
.steps { display: flex; list-style: none; margin: 0; padding: 0; }
.step { position: relative; display: flex; flex-direction: column; align-items: center; width: 92px; }
.step__line { position: absolute; top: 17px; right: 50%; width: 100%; margin-right: 18px; height: 0; border-top: 2px solid #e2e8f0; }
.step__line--done { border-top-color: #10b981; }
.step__line--next { border-top: 2px dotted #94a3b8; }
.step__circle { position: relative; z-index: 1; width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background: #fff; border: 2px solid #e2e8f0; font: 400 14px Inter, sans-serif; color: #94a3b8; transition: background 0.3s, border-color 0.3s, color 0.3s; }
.step--active .step__circle { background: #3b82f6; border-color: #3b82f6; color: #fff; font-weight: 500; box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.18); }
.step--done .step__circle { background: #10b981; border-color: #10b981; color: #fff; }
.step__circle .mdi { font-size: 16px; }
.step__circle--pulse { animation: pulse 0.4s ease-in-out; }
.step__label { margin-top: 4px; font: 400 10px Inter, sans-serif; color: #94a3b8; white-space: nowrap; }
.step--active .step__label { color: #3b82f6; font-weight: 500; }
.bar__info { font: 400 11px Inter, sans-serif; color: #94a3b8; text-align: right; }

@keyframes pulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.15); } }

@media (max-width: 760px) {
  .bar { padding: 0 12px; }
  .step { width: 56px; }
  .bar__info { display: none; }
}
@media (prefers-reduced-motion: reduce) {
  .step__circle { transition: none; }
  .step__circle--pulse { animation: none; }
}
</style>